
// src/pages/maintenance/components/MaintenanceContractList/maintenanceContractFields.js
import API_BASE_URL from "../../../../Constants";

const contractStatusOptions = [
  { key: "Active", label: "Active" },
  { key: "Expired", label: "Expired" },
  { key: "On Hold", label: "On Hold" },
  { key: "Cancelled", label: "Cancelled" },
  { key: "Pending", label: "Pending" },
  { key: "Other", label: "Other" }
]

const basicContractInfo = [
  { key: 'contractNumber', label: 'Contract Number', type: 'text', required: true },
  { key: 'contractClass', label: 'Contract Class', type: 'select', optionsKey: 'contractClass', optionLabel: 'contractClass', optionValue: 'contractClass', required: true },
  { key: 'contractStatus', label: 'Contract Status', type: 'select', options: contractStatusOptions, required: true }
];

const coverageInfo = [
  { key: 'coverageStartDate', label: 'Coverage Start Date', type: 'date', required: true },
  { key: 'coverageEndDate', label: 'Coverage End Date', type: 'date', required: true },
  { key: 'coverageType', label: 'Coverage Type', type: 'select', optionsKey: 'coverageType', optionLabel: 'coverageTypeName', optionValue: 'coverageTypeName', required: true },
  { key: 'coverage', label: 'Coverage', type: 'select', optionsKey: 'coverage', optionLabel: 'coverageName', optionValue: 'coverageName', required: true }
];

const billingInfo = [
  { key: 'visitFrequency', label: 'Visit Frequency', type: 'select', optionsKey: 'visitFrequency', optionLabel: 'visitFrequencyName', optionValue: 'visitFrequencyName', required: true },
  { key: 'billingFrequency', label: 'Billing Frequency', type: 'select', optionsKey: 'billingFrequency', optionLabel: 'billingFrequencyName', optionValue: 'billingFrequencyName', required: true },
  { key: 'billingLevel', label: 'Billing Level', type: 'select', optionsKey: 'billingLevel', optionLabel: 'billingLevelName', optionValue: 'billingLevelName', required: true },
  { key: 'invoiceAmount', label: 'Invoice Amount', type: 'number', required: true },

];

const adjustmentInfo = [
  { key: 'increaseDate', label: 'Increase Date', type: 'date', required: false },
  { key: 'holdPeriod', label: 'Hold Period', type: 'select', optionsKey: 'holdPeriod', optionLabel: 'holdPeriod', optionValue: 'holdPeriod', required: false },
  { key: 'increaseFrequency', label: 'Increase Frequency (Months)', type: 'number', required: false },
  { key: 'increasePercent', label: 'Increase Percent', type: 'number', required: false },

];

const contractFields = [
  { key: 'contractNumber', label: 'Contract Number', type: 'text', required: true },
  { key: 'contractClass', label: 'Contract Class', type: 'select', optionsKey: 'contractClass', optionLabel: 'contractClass', optionValue: 'contractClass', required: true },
  { key: 'coverageStartDate', label: 'Coverage Start Date', type: 'date', required: true },
  { key: 'coverageEndDate', label: 'Coverage End Date', type: 'date', required: true },
  { key: 'coverageType', label: 'Coverage Type', type: 'select', optionsKey: 'coverageType', optionLabel: 'coverageTypeName', optionValue: 'coverageTypeName', required: true },
  { key: 'coverage', label: 'Coverage', type: 'select', optionsKey: 'coverage', optionLabel: 'coverageName', optionValue: 'coverageName', required: true },
  { key: 'visitFrequency', label: 'Visit Frequency', type: 'select', optionsKey: 'visitFrequency', optionLabel: 'visitFrequencyName', optionValue: 'visitFrequencyName', required: true },
  { key: 'billingFrequency', label: 'Billing Frequency', type: 'select', optionsKey: 'billingFrequency', optionLabel: 'billingFrequencyName', optionValue: 'billingFrequencyName', required: true },
  { key: 'billingLevel', label: 'Billing Level', type: 'select', optionsKey: 'billingLevel', optionLabel: 'billingLevelName', optionValue: 'billingLevelName', required: true },
  { key: 'invoiceAmount', label: 'Invoice Amount', type: 'number', required: true },
  { key: 'increaseDate', label: 'Increase Date', type: 'date', required: false },
  { key: 'holdPeriod', label: 'Hold Period', type: 'select', optionsKey: 'holdPeriod', optionLabel: 'holdPeriod', optionValue: 'holdPeriod', required: false },
  { key: 'increaseFrequency', label: 'Increase Frequency (Months)', type: 'number', required: false },
  { key: 'increasePercent', label: 'Increase Percent', type: 'number', required: false },
];



export const ContractFieldsView = [

  {
    key: 'contractNumber',
    label: 'Contract Number',
    type: 'text',
    required: true,

  },
  {
    key: 'contractClass',
    label: 'Contract Class',
    type: 'select',
    optionsKey: 'contractClass',
    optionLabel: 'contractClass',
    optionValue: 'contractClass',
    required: true,
  },

  {
    key: 'contractStatus',
    label: 'Contract Status',
    type: 'select',
    options: contractStatusOptions,
    required: true,
  }
  ,
  {
    key: 'coverageStartDate',
    label: 'Coverage Start Date',
    type: 'date',
    required: true,

  }, {

    key: 'coverageEndDate',
    label: 'Coverage End Date',
    type: 'date',
    required: true,

  },
  {
    key: 'coverageType',
    label: 'Coverage Type',
    type: 'select',
    optionsKey: 'coverageType',
    optionLabel: 'coverageTypeName',
    optionValue: 'coverageTypeName',
    required: true,
  },

  {
    key: 'coverage',

    label: 'Coverage',
    type: 'select',
    optionsKey: 'coverage',
    optionLabel: 'coverageName',
    optionValue: 'coverageName',
    required: true,
  },

  {
    key: 'visitFrequency',
    label: 'Visit Frequency',
    type: 'select',
    optionsKey: 'visitFrequency',
    optionLabel: 'visitFrequencyName',
    optionValue: 'visitFrequencyName',
    required: true,


  },
  {
    key: 'billingLevel',
    label: 'Billing Level',
    type: 'select',
    optionsKey: 'billingLevel',
    optionLabel: 'billingLevelName',
    optionValue: 'billingLevelName',
    required: true,

  },
  {
    key: 'billingFrequency',
    label: 'Billing Frequency',
    type: 'select',

    optionsKey: 'billingFrequency',
    optionLabel: 'billingFrequencyName',
    optionValue: 'billingFrequencyName',
    required: true,
  },

  {
    key: 'invoiceAmount',
    label: 'Invoice Amount',
    type: 'number',

    required: true,

  },
  {
    key: 'increaseDate',
    label: 'Increase Date',
    type: 'date',
    required: false,

  },
  {
    key: 'increasePercent',
    label: 'Increase Percent',
    type: 'number',
    required: false,

  }, {

    key: 'increaseFrequency',
    label: 'Increase Frequency (Months)',
    type: 'number',
    required: false,
  }, {
    key: 'holdPeriod',
    label: 'Hold Period',
    type: 'select',
    optionsKey: 'holdPeriod',
    optionLabel: 'holdPeriod',
    optionValue: 'holdPeriod',
    required: false,
  }
]



export const ContractDetailsFields = [

  {
    name: 'contractNumber',
    label: 'Contract Number',
    type: 'text',
    required: true,
  },
  {
    name: 'contractClass',
    label: 'Contract Class',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/contractclasses',
    optionLabel: 'contractClass',
    optionValue: 'contractClass',
    required: true,
  },
  {
    name: 'coverageStartDate',
    label: 'Coverage Start Date',
    type: 'date',
    required: true,
  },
];

export const CoverageFields = [
  {
    name: 'coverageType',
    label: 'Coverage Type',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenancecoveragetypes',
    optionLabel: 'coverageTypeName',
    optionValue: 'coverageTypeName',
    required: true,
  },
  {
    name: 'coverage',
    label: 'Coverage',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenancecoverages',
    optionLabel: 'coverageName',
    optionValue: 'coverageName',
    required: true,
  },
  {
    name: 'visitFrequency',
    label: 'Visit Frequency',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenancefrequencies',
    optionLabel: 'visitFrequencyName',
    optionValue: 'visitFrequencyName',
    required: true,
  },
];

export const BillingInformationFields = [
  {
    name: 'billingLevel',
    label: 'Billing Level',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenancebillinglevels',
    optionLabel: 'billingLevelName',
    optionValue: 'billingLevelName',
    required: true,
  },
  {
    name: 'billingFrequency',
    label: 'Billing Frequency',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenancebillingfrequencies',
    optionLabel: 'billingFrequencyName',
    optionValue: 'billingFrequencyName',
  },
  {
    name: 'invoiceAmount',
    label: 'Invoice Amount',
    type: 'number',
    required: true,
  },
];

export const IncreaseDetailsFields = [
  {
    name: 'increaseDate',
    label: 'Increase Date',
    type: 'date',
    required: false,
  },
  {
    name: 'increasePercent',
    label: 'Increase Percent',
    type: 'number',
    required: false,
  },
  {
    name: 'increaseFrequency',
    label: 'Increase Frequency',
    type: 'text',
    required: false,
  },
  {
    name: 'holdPeriod',
    label: 'Hold Period',
    type: 'select',
    fetchUrl: API_BASE_URL + '/api/maintenance/maintenanceholdperiods',
    optionLabel: 'holdPeriod',
    optionValue: 'holdPeriod',
    required: false,
  },
];

// Combine all fields into maintenanceContractFields for easier import in components
export const maintenanceContractFields = [
  ...ContractDetailsFields,
  ...CoverageFields,
  ...BillingInformationFields,
  ...IncreaseDetailsFields,
];

export {
  basicContractInfo,
  coverageInfo,
  billingInfo,
  adjustmentInfo,
  contractFields
};
